import { render, staticRenderFns } from "./IndustryInformationDetail.vue?vue&type=template&id=2758bfc7&"
import script from "./IndustryInformationDetail.vue?vue&type=script&lang=js&"
export * from "./IndustryInformationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports